import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Nightlife = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddNightlife = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditNightlife = () => {
  return (
    
      
        <Edit />
      
    
  );
};
